// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-templates-page-template-js" + "-" + "05f29d4cb685dbd54d60" + ".js";
};